import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatUrlPathname(pathname: string): string {
  // Trim leading and trailing spaces
  pathname = pathname.trim()

  // Replace backslashes with forward slashes
  pathname = pathname.replace(/\\/g, '/')

  // Remove duplicate slashes
  pathname = pathname.replace(/\/+/g, '/')

  // Ensure it starts with a single slash
  if (!pathname.startsWith('/')) {
    pathname = '/' + pathname
  }

  // Remove trailing slash if it's not the root
  if (pathname.length > 1 && pathname.endsWith('/')) {
    pathname = pathname.slice(0, -1)
  }

  return pathname
}
